import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'allResidentsTypeInput',
    'integrationAuditLabel',
    'integrationEndDateInput',
    'integrationStartDateInput',
    'manualAuditLabel',
    'newLeasesTypeInput',
    'periodInput',
  ]

  connect() {
    this.updatePeriod()
  }

  toggleType(event) {
    if (!event.currentTarget.classList.contains('disabled')) {
      [this.integrationAuditLabelTarget, this.manualAuditLabelTarget].
        forEach((label) => label.classList.remove('active'))

      event.target.classList.add('active')
      this.updatePeriod()
    }
  }

  updatePeriod() {
    if (this.manualAuditLabelTarget.classList.contains('active')) {
      this.periodInputTarget.value = new Date().toISOString().substring(0, 10)
    } else if (this.newLeasesTypeInputTarget.checked) {
      this.periodInputTarget.value = this.integrationStartDateInputTarget.value
    } else {
      this.periodInputTarget.value = this.integrationEndDateInputTarget.value
    }
  }
}
